export const environment = {
  production: true,


  server: {
    mainURL: 'https://test.avs-api.com/price-matcher/',
    authURL: 'https://test.avs-api.com/',
    domain: 'https://test-price-matcher.avsemprize.com/',
    key: 'a3a625d133af5abf650ba9c701381d9c',
    project: 'price_matcher',
    auth_token: 'pm_token'
  },
};
